import React, { useEffect, useState } from 'react'
import endpoint from "../../../auth/endpoint";
import { Link, Navigate } from "react-router-dom";
import Loader from "react-loader-advanced";
import './printCauseList.css'

const ResaultOfApplicationSearch = () => {

    const [isLoading, setLoading] = useState(false);
    const [dailyCauseList, setDailyCauseList] = useState([]);
    const [searchParams, setSearchParams] = useState({
        fdate: '',
        tdate: '',
        suitno: '',
        parties: '',
        registry: ''
    });
    const [registries, setRegistries] = useState([]);
    const [hasSearched, setHasSearched] = useState(false);

    const dateSuffix = (day) => {
        if ((day == 1) || (day == 21) || (day == 31)) {
            return day + '' + "st";
        } else if ((day == 2) || (day == 22)) {
            return day + '' + "nd";
        } else if ((day == 3) || (day == 23)) {
            return day + '' + "rd";
        } else {
            return day + '' + "th";
        }
    }

    const formattedDate = searchParams.fdate && (new Date(searchParams.fdate).toLocaleDateString('en-us', { weekday: "long" }) + ", " + dateSuffix(new Date(searchParams.fdate).toLocaleDateString('en-us', { day: "numeric" })) + " day of " +
        new Date(searchParams.fdate).toLocaleDateString('en-us', { month: "long" }) + ", " + new Date(searchParams.fdate).toLocaleDateString('en-us', { year: "numeric" })).toUpperCase();

    const curDate = new Date()
    const dateStr = (curDate.toLocaleDateString('en-us', { weekday: "long" }) + ", " + dateSuffix(curDate.toLocaleDateString('en-us', { day: "numeric" })) + " day of " +
        curDate.toLocaleDateString('en-us', { month: "long" }) + ", " + curDate.toLocaleDateString('en-us', { year: "numeric" })).toUpperCase();

    const alphabetArray = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

    // Fetch registries from API
    useEffect(() => {
        const fetchRegistries = async () => {
            try {
                const response = await endpoint.get('/court-room/list');
                console.log("Registries API response:", response.data);
                
                if (response.data.success) {
                    setRegistries(response.data.data || []);
                } else {
                    setRegistries([]);
                }
            } catch (error) {
                console.error('Error fetching registries:', error);
                setRegistries([]);
            }
        };
        
        fetchRegistries();
    }, []);

    const handleFetchData = async () => {
        setLoading(true);
        setHasSearched(true);
        
        try {
            // Convert parameters to match backend API
            const apiParams = {
                from_date: searchParams.fdate,
                to_date: searchParams.tdate,
                appeal_number: searchParams.suitno,
                parties: searchParams.parties,
                registry: searchParams.registry
            };

            // Remove empty parameters
            Object.keys(apiParams).forEach(key => {
                if (!apiParams[key]) {
                    delete apiParams[key];
                }
            });

            const queryString = new URLSearchParams(apiParams).toString();
            const url = queryString 
                ? `/cause-list/new-day-history-list-website?${queryString}`
                : `/cause-list/new-day-history-list-website`;

            const response = await endpoint.get(url);
            console.log("response with search parameters", response.data);

            if (response.data.success) {
                let causeArr = response.data.data || [];

                const groupedByLocation = causeArr.reduce((result, obj) => {
                    const location = obj.location || 'N/A';

                    if (!result[location]) {
                        result[location] = {};
                    }

                    const key = obj.CaseType?.case_type + ' ' + obj.CaseTypeCategory?.case_type_cat + ' ' + (obj.AdjournmentType?.id == 2 ? obj.AdjournmentType.id : '');

                    if (!result[location][key]) {
                        result[location][key] = [];
                    }

                    result[location][key].push(obj);

                    return result;
                }, {});
                
                console.log("groupedPrayerByLocation", groupedByLocation);
                setDailyCauseList(groupedByLocation);
            } else {
                setDailyCauseList([]);
            }
        } catch (err) {
            console.log(err);
            setDailyCauseList([]);
        }
        setLoading(false);
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSearchParams(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const handleReset = () => {
        setSearchParams({
            fdate: "",
            tdate: "",
            suitno: "",
            parties: "",
            registry: ""
        });
        setDailyCauseList([]);
        setHasSearched(false);
    }

    // Format date function from second code
    const formatDateWithYear = (dateString) => {
        if (!dateString || dateString === "0000-00-00") return "N/A";

        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.toLocaleString("en-GB", { month: "long" });
        const year = date.getFullYear();
        const weekday = date.toLocaleString("en-GB", { weekday: "long" });

        const getOrdinal = (n) => {
            if (n > 3 && n < 21) return "th";
            switch (n % 10) {
                case 1: return "st";
                case 2: return "nd";
                case 3: return "rd";
                default: return "th";
            }
        };

        return `${weekday} ${day}${getOrdinal(day)} ${month} ${year}`;
    };

    // Group data by date and court like in second code
    const groupByDayMonthAndCourt = (data) => {
        if (!Array.isArray(data)) return {};
        
        return data.reduce((acc, item) => {
            if (!item.date_held) return acc;
            
            const date = new Date(item.date_held);
            const day = date.getDate();
            const month = date.getMonth();
            const court = item.location || "UNKNOWN COURT";
            const key = `${day}-${month}-${court}`;
            
            if (!acc[key]) {
                acc[key] = {
                    dateString: formatDateWithYear(item.date_held),
                    court: court,
                    cases: [],
                    dateObj: new Date(date.getFullYear(), month, day)
                };
            }
            
            acc[key].cases.push(item);
            return acc;
        }, {});
    };

    const getSortedGroups = () => {
        // Flatten the dailyCauseList structure to match the second code's data structure
        const allCases = [];
        Object.values(dailyCauseList).forEach(locationGroup => {
            Object.values(locationGroup).forEach(caseGroup => {
                allCases.push(...caseGroup);
            });
        });

        const grouped = groupByDayMonthAndCourt(allCases);
        return Object.values(grouped).sort((a, b) => a.dateObj - b.dateObj || a.court.localeCompare(b.court));
    };

    const sortedGroups = getSortedGroups();

    //function that adds "judgement" to heading
    const splitHeading = (str) => {
        const firstSpaceIndex = str.indexOf(' ')
        const firstPart = str.slice(0, firstSpaceIndex)
        return (firstPart + ' ' + 'Judgment').toUpperCase()
    }

    //function that removes the adjournment id from heading
    const removeNumber = (str) => {
        const result = str.replace(/[0-9]/g, '')
        return (result + ' ' + '(s)').toUpperCase()
    }

    return (
        <>
            <div id='divToPrint'>
                <div className='col-md-12 text-center' id='hideDate' style={{ textDecoration: `underline` }}> 
                    <h3>SEARCH RESULT OF APPLICATIONS</h3><br />
                </div>

                <div className='row mt-4'>
                    <div className='col'>
                        <label className='text-danger' id='hideDate'>
                            <i>**Please select search parameters and click on search to print return of applications**</i>
                        </label>
                        
                        {/* Search Form */}
                        <div className="card mb-4" id='hideDate'>
                            <div className="card-body">
                                {/* First Row: Registry, Date From, Date To, Appeal Number */}
                                <div className="row mt-2">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="registry">Registry</label>
                                            <select 
                                                className="form-control" 
                                                id="registry"
                                                name="registry"
                                                value={searchParams.registry}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Select Registry</option>
                                                {registries.map(registry => (
                                                    <option key={registry.id} value={registry.name}>
                                                        {registry.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="fdate">Date From</label>
                                            <input 
                                                type="date" 
                                                className="form-control" 
                                                id="fdate"
                                                name="fdate"
                                                value={searchParams.fdate}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="tdate">Date To</label>
                                            <input 
                                                type="date" 
                                                className="form-control" 
                                                id="tdate"
                                                name="tdate"
                                                value={searchParams.tdate}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="suitno">Appeal Number</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                id="suitno"
                                                name="suitno"
                                                placeholder="Enter appeal number"
                                                value={searchParams.suitno}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                
                                {/* Second Row: Parties (full width) */}
                                <div className="row mt-2">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label htmlFor="parties">Parties</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                id="parties"
                                                name="parties"
                                                placeholder="Enter party name"
                                                value={searchParams.parties}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                    
                                {/* Buttons Row */}
                                <div className="row mt-3">
                                    <div className="col-md-12">
                                        <div className="d-flex gap-2">
                                            <button 
                                                className="btn btn-primary" 
                                                type="button" 
                                                onClick={handleFetchData}
                                            >
                                                Search
                                            </button>
                                            <button 
                                                className="btn btn-outline-secondary" 
                                                type="button" 
                                                onClick={handleReset}
                                            >
                                                Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {isLoading && <Loader />}

                {!isLoading && hasSearched && (
                    <div className='row mt-4'>
                        <div className='col-md-12'>
                            {sortedGroups.length > 0 ? (
                                sortedGroups.map((group, groupIndex) => (
                                    <div key={groupIndex}>
                                        {/* Location Header */}
                                        <div className='text-center mb-4' style={{ fontWeight: 'bold', fontSize: '18px', textDecoration: 'underline' }}>
                                            RESULT OF APPLICATIONS FOR {group.dateString.toUpperCase()} <br />
                                            {group.court.toUpperCase()}
                                        </div>

                                        {/* Group cases by type */}
                                        {(() => {
                                            const groupedByType = group.cases.reduce((result, item) => {
                                                const caseType = item.CaseType?.case_type || 'Civil';
                                                const category = item.CaseTypeCategory?.case_type_cat || 'Appeal';
                                                const adjournmentType = item.AdjournmentType?.id === 2 ? 'For Judgment' : '';
                                                
                                                const key = `${caseType} ${category} ${adjournmentType}`.trim();
                                                
                                                if (!result[key]) {
                                                    result[key] = [];
                                                }
                                                
                                                result[key].push(item);
                                                return result;
                                            }, {});

                                            return Object.entries(groupedByType)
                                                .sort(([keyA], [keyB]) => {
                                                    const isMotionA = keyA.toLowerCase().includes("motion");
                                                    const isMotionB = keyB.toLowerCase().includes("motion");

                                                    if (isMotionA && !isMotionB) return -1;
                                                    if (!isMotionA && isMotionB) return 1;
                                                    return keyA.localeCompare(keyB);
                                                })
                                                .map(([headings, items], index) => (
                                                    <div className='causeListHeading' key={index}>
                                                        <div className='text-center mb-2' style={{
                                                            color: `${headings.toUpperCase().includes("CIVIL") ? 'green' : headings.toUpperCase().includes("CRIMINAL") ? "red" : headings.toUpperCase().includes("POLITICAL") ? "blue" : ""}`
                                                        }}>
                                                            {headings.includes('2') ? 
                                                                `${alphabetArray[index]}. ${splitHeading(headings)}` : 
                                                                `${alphabetArray[index]}. ${removeNumber(headings)}`
                                                            }
                                                        </div>

                                                        <div className='table-reponsive'>
                                                            <table className="table mb-5" style={{ width: `100%` }}>
                                                                <thead className="thead-light">
                                                                    <tr style={{ border: `1px solid black` }}>
                                                                        <th style={{ maxWidth: `5px`, border: `1px solid black` }}>SN.</th>
                                                                        <th scope="col" style={{ border: `1px solid black` }}>APPEAL NO.</th>
                                                                        {headings.toUpperCase().includes("APPEAL") ?
                                                                            <>
                                                                                <th scope="col" style={{ border: `1px solid black` }}>APPELLANTS</th>
                                                                                <th scope="col" style={{ border: `1px solid black` }}>RESPONDENTS</th>
                                                                                <th scope="col" style={{ border: `1px solid black` }}>APPLICATIONS</th>
                                                                            </>
                                                                            : <>
                                                                                <th scope="col" style={{ border: `1px solid black` }}>PARTIES</th>
                                                                                <th scope="col" style={{ border: `1px solid black` }}>APPLICATIONS</th>
                                                                            </>
                                                                        }
                                                                    </tr>
                                                                </thead>

                                                                <tbody>
                                                                    {items.map((item, index) => (
                                                                        <React.Fragment key={index}>
                                                                            {item.CaseAttachementHistories && item.CaseAttachementHistories.map((Case, index2) => (
                                                                                <tr key={`${index}-${index2}`} style={{ border: `1px solid black` }}>
                                                                                    {(index2 === 0) && <td rowSpan={item.CaseAttachementHistories.length} style={{ border: `1px solid black` }}>{index + 1}.</td>}
                                                                                    <td style={{ border: `1px solid black`, color: `${item.CaseType?.case_color || 'green'}` }}>{Case.suite_no}</td>
                                                                                    {headings.toUpperCase().includes("APPEAL") ?
                                                                                        <>
                                                                                            <td style={{ whiteSpace: `normal`, border: `1px solid black` }}>
                                                                                                {Case.appellants} {Case.otherAppellantCount === 1 ? (
                                                                                                    <><strong> & Anor </strong></>
                                                                                                ) : Case.otherAppellantCount > 1 ? (
                                                                                                    <> & <strong>{Case.otherAppellantCount} Ors</strong></>
                                                                                                ) : (
                                                                                                    ""
                                                                                                )}
                                                                                            </td>
                                                                                            <td style={{ whiteSpace: `normal`, border: `1px solid black` }}>
                                                                                                {Case.respondent}
                                                                                                {Case.otherRespondentCount === 1 ? (
                                                                                                    <><strong> & Anor </strong></>
                                                                                                ) : Case.otherRespondentCount > 1 ? (
                                                                                                    <> & <strong>{Case.otherRespondentCount} Ors</strong></>
                                                                                                ) : (
                                                                                                    ""
                                                                                                )}
                                                                                            </td>
                                                                                            <td style={{ whiteSpace: `pre-wrap`, border: `1px solid black`, wordWrap: `break-word` }}>
                                                                                            {item.Remarks && item.Remarks.length > 0 ? (
                                                                                                item.Remarks.filter((justice) => justice.Justice).map((remark, rIndex) => (
                                                                                                <div key={rIndex} style={{ padding: "4px 0", borderBottom: "1px solid #ccc" }}>
                                                                                                    {remark.remark} <br></br>
                                                                                                    <span style={{paddingTop: '10px', paddingBottom: '10px'}}><strong>{remark.Justice?.name?.replace(", JSC", "").replace(", GCON", "")}</strong></span>
                                                                                                </div>
                                                                                                ))
                                                                                            ) : (
                                                                                                <em>No remarks recorded</em>
                                                                                            )}
                                                                                            </td>
                                                                                        </>
                                                                                        :
                                                                                        <>
                                                                                            <td className='text-center' style={{ whiteSpace: `normal`, border: `1px solid black` }}>
                                                                                                {Case.appellants}{Case.otherAppellantCount === 1 ? (
                                                                                                    <><strong> & Anor </strong></>
                                                                                                ) : Case.otherAppellantCount > 1 ? (
                                                                                                    <> & <strong>{Case.otherAppellantCount} Ors</strong></>
                                                                                                ) : (
                                                                                                    ""
                                                                                                )}
                                                                                                <tr><div className='mt-2 mb-2'>VS.</div></tr>
                                                                                                {Case.respondent}{Case.otherRespondentCount === 1 ? (
                                                                                                        <><strong> & Anor </strong></>
                                                                                                    ) : Case.otherRespondentCount > 1 ? (
                                                                                                        <> & <strong>{Case.otherRespondentCount} Ors</strong></>
                                                                                                    ) : (
                                                                                                        ""
                                                                                                    )}
                                                                                            </td>
                                                                                            <td style={{ whiteSpace: `pre-wrap`, border: `1px solid black`, wordWrap: `break-word` }}>
                                                                                            {item.Remarks && item.Remarks.length > 0 ? (
                                                                                                item.Remarks.filter((justice) => justice.Justice).map((remark, rIndex) => (
                                                                                                <div key={rIndex} style={{ padding: "4px 0", borderBottom: "1px solid #ccc" }}>
                                                                                                    {remark.remark} <br></br>
                                                                                                    <span style={{paddingTop: '10px', paddingBottom: '10px'}}><strong>{remark.Justice?.name?.replace(", JSC", "").replace(", GCON", "")}</strong></span>
                                                                                                </div>
                                                                                                ))
                                                                                            ) : (
                                                                                                <em>No remarks recorded</em>
                                                                                            )}
                                                                                            </td>
                                                                                        </>
                                                                                    }
                                                                                </tr>
                                                                            ))}
                                                                        </React.Fragment>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                ))
                                        })()}
                                    </div>
                                ))
                            ) : (
                                <div className="text-center p-5">
                                    <p>No application results found matching your search criteria</p>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {!hasSearched && !isLoading && (
                    <div className="text-center p-5">
                        <p>Please use the search form above to find application results.</p>
                    </div>
                )}

                {sortedGroups.length > 0 &&
                    <div className='col-md-12 hideBtn'>
                        <button className="btn btn-outline-primary" type="button" onClick={() => window.print()} id="button-addon2">Print</button>
                    </div>
                }
            </div>
        </>
    )
}

export default ResaultOfApplicationSearch;